/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiTenantProvider;
(function (ApiTenantProvider) {
    ApiTenantProvider["TENANT_PROVIDER_UNSPECIFIED"] = "TenantProviderUnspecified";
    ApiTenantProvider["TENANT_PROVIDER_MICROSOFT"] = "TenantProviderMicrosoft";
})(ApiTenantProvider || (ApiTenantProvider = {}));
export function ApiTenantProviderFromJSON(json) {
    return ApiTenantProviderFromJSONTyped(json, false);
}
export function ApiTenantProviderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiTenantProviderToJSON(value) {
    return value;
}
